import PropTypes from "prop-types";
import classNames from "classnames";
import "./ChevronDown.scss";

const ChevronDown = ({
	className,
	rotated = false,
	size = 16,
	fill = "currentColor",
	...props
}) => {
	const chevronDownClassName = classNames("chevron-down-icon", className, {
		"chevron-down-icon--rotated": rotated,
	});

	return (
		<svg
			className={chevronDownClassName}
			width={size}
			height={size}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M16.59 8.295L12 12.875L7.41 8.295L6 9.705L12 15.705L18 9.705L16.59 8.295Z"
				fill={fill}
			/>
		</svg>
	);
};

ChevronDown.propTypes = {
	className: PropTypes.string,
	rotated: PropTypes.bool,
	fill: PropTypes.string,
	size: PropTypes.number,
};

export default ChevronDown;
